import { HlmSpinner } from './lib/hlm-spinner';

export * from './lib/hlm-spinner';

export const HlmSpinnerImports = [HlmSpinner] as const;
